import { CompetenceGroups } from "./competencegroups.component";
import { CompetenceGroup } from "./competencegroup.component";
import { EditCompetenceGroup } from "./competencegroup.edit.component";
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { UIRouterModule } from "@uirouter/angular";
import { competenceGroupsState, competenceGroupState, newCompetenceGroupState, editCompetenceGroupState } from "./competencegroups.states";
import { AllMaterialModule } from "../../all-material.components";
import { FlexLayoutModule } from "@angular/flex-layout";

import SharedModule from "../../shared/shared.module";
import { CoreModule } from "../../core/core.module";

let COMPETENCE_GROUPS_STATES = [competenceGroupsState, competenceGroupState, newCompetenceGroupState, editCompetenceGroupState];

import { ConfirmDialog } from "../../shared/confirm-dialog.component";

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        AllMaterialModule,
        SharedModule,
        CoreModule,
        FlexLayoutModule,
        UIRouterModule.forChild({ states: COMPETENCE_GROUPS_STATES })
    ],
    declarations: [CompetenceGroups, CompetenceGroup, EditCompetenceGroup],
    entryComponents: [ConfirmDialog]
})
export default class CompetenceGroupsModule {
}


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./node_modules/tslint-loader!./client/app/settings/competencegroups/competencegroups.module.ts